import { format } from "path";

export class SelfTestPelletizing {
    constructor({
          id= null, 
          testCode= ``, 
          testDateStr=``,
          locName= ``, 
          testShift= ``,
          testStartTimeStr='',
          testEndTimeStr='',
          testOutput='',
          testMatName='',
          testOperationRate='',
          locId = '',
          
      } = {}) {
      this.id = id;
      this.testCode = testCode;
      this.testDateStr = testDateStr;
      this.locName = locName;
      this.testShift = testShift;
      this.testStartTimeStr=testStartTimeStr;
      this.testEndTimeStr=testEndTimeStr;
      this.testOperationRate=testOperationRate;
      this.testOutput=testOutput;
      this.testMatName=testMatName;
      this.locId = locId;
      
    }
  }
  export function gridFields() {
    return Object.freeze([ 
     
        {
            key: 'testCode',
            label: 'lbl.selfTestPelletizing.testCode',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
          key: 'testDate',
          label: 'lbl.selfTestPelletizing.testTime',
          sortable: true,
          form: {
            type: 'date'
          }
        },
        {
          key: 'testStartTime',
          label: 'lbl.selfTestPelletizing.testStartTime',
          sortable: true,
          form: {
            type: 'dateTime'
          }
        },
        {
          key: 'testEndTime',
          label: 'lbl.selfTestPelletizing.testEndTime',
          sortable: true,
          form: {
            type: 'dateTime'
          }
        },
        {
          key: 'locName',
          label: 'lbl.selfTestPelletizing.testPlant',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'testShift',
          label: 'lbl.selfTestPelletizing.testShift',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'testMatName',
          label: 'lbl.selfTestPelletizing.testMatName',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'testOutput',
          label: 'lbl.selfTestPelletizing.testOutput',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'testOperationRate',
          label: 'lbl.selfTestPelletizing.testOperationRate',
          sortable: true,
          form: {
            type: 'input'
          }
        }       
    ]);
  }
  
  export const fields = Object.freeze(Object.keys(new SelfTestPelletizing()).map(i => 'entity.' + i));
  export const filterFields = [
    'filter.testCodeFilter',
    'filter.startDateFilter',
    'filter.endDateFilter',
    'filter.locNameFilter',
    'filter.testShiftFilter',
    'filter.testMatNameFilter',
   
  ];
  export const filter = {
    'testCodeFilter': "",
    'startDateFilter':formate(new Date()),
    'endDateFilter':formate(new Date()),
    'locNameFilter':"default",
    'testShiftFilter':"",
    'testMatNameFilter':"",
    
    
  };

  export function formate(date)  {

    var y=date.getFullYear();
    var m=date.getMonth()+1;
    var d=date.getDate();
    var h=date.getHours();
    m=m<10 ? '0'+m :m;
    if(h>=8){
      d=d<10 ? '0'+d :d;
    }else{
      d=(d-1)<10 ? '0'+d-1 :d-1;
    }
    

    return y+'-'+m+'-'+d;

  }